import { Outlet } from '@tanstack/react-router';

import { TopBar } from './TopBar';
import { LoadingProvider } from './loading/LoadingProvider';

export function AppLayout() {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-gray-50">
      {/* ── Navbar ── */}
      <TopBar />
      <LoadingProvider>

        {/* ── Page content ── */}
        <main className="flex flex-1 flex-col overflow-hidden">
          <Outlet />
        </main>

      </LoadingProvider>
    </div>
  );
}
